import { DateFilterModel } from '@/core/interfaces/data-filter'
import dayjs, { OpUnitType } from 'dayjs'
import {
  getEndDateISOString,
  getOffsetDateISOString,
  getStartDateISOString,
} from './getOffset'

const isToday = (date: Date): boolean => {
  const today = new Date()
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  )
}

export const getFilterTimeUTC = (
  value = 7, // Value for the time interval
  unit: OpUnitType = 'week', // Time period
  fromDate?: Date | undefined,
  toDate?: Date | undefined,
): DateFilterModel => {
  const currentDateISOString = getOffsetDateISOString()

  if (fromDate && toDate) {
    const isToDateToday = isToday(toDate)
    return {
      startDate: getStartDateISOString(fromDate),
      endDate: isToDateToday
        ? currentDateISOString
        : getEndDateISOString(toDate),
    }
  }

  // switch (unit) {
  //   case 'day': {
  //     return {
  //       startDate: getStartDateISOString(),
  //       endDate: currentDateISOString,
  //     }
  //   }
  //   case 'week':
  //     return {
  //       startDate: getStartDateISOString(dayjs().subtract(6, 'days').toDate()),
  //       endDate: currentDateISOString,
  //     }
  //   default:
  //     return {
  //       startDate: getStartDateISOString(
  //         dayjs().subtract(value, unit).toDate(),
  //       ),
  //       endDate: currentDateISOString,
  //     }
  // }

  switch (unit) {
    case 'day': {
      return {
        startDate: getStartDateISOString(dayjs().subtract(1, 'year').toDate()),
        endDate: currentDateISOString,
      }
    }
    case 'week':
      return {
        startDate: getStartDateISOString(dayjs().subtract(3, 'month').toDate()),
        endDate: currentDateISOString,
      }

    case 'month':
      return {
        startDate: getStartDateISOString(dayjs().subtract(6, 'month').toDate()),
        endDate: currentDateISOString,
      }

    default:
      return {
        startDate: getStartDateISOString(
          dayjs().subtract(value, unit).toDate(),
        ),
        endDate: currentDateISOString,
      }
  }
}
